// Modified by Sullivan Digital, 2026-10-26: shows the SALDP white-labelling About / Legal screen (attribution, AGPL notice, source offer). Licensed under the GNU AGPL v3.
import { AboutContent } from "metabase/saldp-branding/components/AboutContent/AboutContent";
import { Modal, type ModalProps } from "metabase/ui";

export const AboutModal = ({
  onClose,
  opened,
}: Pick<ModalProps, "onClose" | "opened">) => {
  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false} size={520}>
      <AboutContent />
    </Modal>
  );
};
